import {BottomSheet} from 'react-spring-bottom-sheet';
import {useNavigate} from 'react-router-dom';

import ToggleSwitch from '../../../../../../components/mazraeKit/toggleSwitch';

interface IActivateEditedBottomSheet {
  openActivateEditedBottomSheet: boolean;
  setOpenActivateEditedBottomSheet: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  onToggle: () => void;
  isToggle: boolean;
  data?: ISupplier_profile;
}

const ActivateEditedBottomSheet = ({
  openActivateEditedBottomSheet,
  setOpenActivateEditedBottomSheet,
  onToggle,
  isToggle,
  data,
}: IActivateEditedBottomSheet) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    if (data?.store?.guid) {
      navigate(`/edit-register-store/store/${data.store?.guid}`, {
        state: {tab: 2},
      });
    } else if (data?.lab?.guid) {
      navigate(`/edit-register-store/lab/${data?.lab?.guid}`, {
        state: {tab: 2},
      });
    }
  };

  return (
    <BottomSheet
      onDismiss={() => setOpenActivateEditedBottomSheet(false)}
      open={openActivateEditedBottomSheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col">
        <div className="flex justify-end px-2">
          <i
            className="icon-nameClose-remove"
            onClick={e => {
              e.stopPropagation();
              setOpenActivateEditedBottomSheet(false);
            }}
          />
        </div>

        <div className="flex flex-col gap-4 p-3 ">
          <div
            className="flex gap-2 items-center text-gray-700"
            onClick={handleEdit}
          >
            <i className="icon-nameEdit-Square text-xxxl text-farm-shop-500" />
            <span className="text-gray-900">
              {' '}
              ویرایش اطلاعات {data?.store?.guid ? 'فروشگاه' : 'آزمایشگاه'}
            </span>
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex gap-2">
              <ToggleSwitch
                isToggled={isToggle}
                onToggle={onToggle}
                size="xs"
              />
              <div className="text-gray-900">
                وضعیت {data?.store?.guid ? 'فروشگاه' : 'آزمایشگاه'}:{' '}
                {isToggle ? 'فعال' : 'غیر فعال'}
              </div>
            </div>
            <span className="text-gray-600 text-sm">
              درصورت غیرفعال کردن {data?.store?.guid ? 'فروشگاه' : 'آزمایشگاه'}{' '}
              آگهی‌های فعال نمایش داده نمی‌شوند.
            </span>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default ActivateEditedBottomSheet;
